import { v4 as uuidv4 } from "uuid";
export const members = [
  {
    id: uuidv4(),
    name: "MR. SHAUKAT ALI CHAUDHRY",
    image: `thumbnail-shaukat.jpg`,
  },
  {
    id: uuidv4(),
    name: "MR. ADNAN ASHRAF",
    image: `thumbnail-adnan.jpg`,
  },
  {
    id: uuidv4(),
    name: "MR. KHAWJA IRFAN UL HAQ",
    image: `thumbnail-irfan.jpg`,
  },
  {
    id: uuidv4(),
    name: "MR. JAWAD IQBAL",
    image: `thumbnail-jawad.jpg`,
  },
  {
    id: uuidv4(),
    name: "MR. SHAMSHAD AHMAD BAJWA",
    image: `thumbnail-shamshad.jpg`,
  },
  {
    id: uuidv4(),
    name: "MR CH. MUHAMMAD YOUSAF",
    image: `thumbnail-yousaf.jpg`,
  },
];
